/**
 * Particle Network Animation Configuration
 */

export const CONFIG = {
	// Particle density: higher = fewer particles (pixels² per particle)
	PARTICLE_DENSITY: 18000,
	// Percentage of particles that are larger "node" particles
	NODE_PROBABILITY: 0.15,
	// Mouse interaction
	MOUSE_ATTRACTION_RADIUS: 300,
	MOUSE_REPULSION_RADIUS: 80,
	MOUSE_GLOW_RADIUS: 150,
	// Particle connections
	CONNECTION_DISTANCE: 150,
	PULSE_CONNECTION_DISTANCE: 200,
	// Physics
	MAX_VELOCITY: 2,
	VELOCITY_DAMPING: 0.98,
	BOUNCE_DAMPING: 0.5,
	// Animation timing
	TIME_STEP: 0.012,
	PULSE_INTERVAL: 0.15,
	// Force constants
	ATTRACTION_FORCE: 0.015,
	REPULSION_FORCE: 0.03,
	RANDOM_MOVEMENT: 0.02,
	// Data stream animation (waves)
	DATA_STREAM_BASE_SPEED: 0.2,
	DATA_STREAM_SPEED_INCREMENT: 0.1,
	// Pulse speed (beaming between particles)
	PULSE_BASE_SPEED: 0.008,
	PULSE_SPEED_VARIANCE: 0.008,
	// Pulse rendering
	PULSE_FREQUENCY: 3,
	PULSE_AMPLITUDE: 0.3,
	INITIAL_VELOCITY: 0.8,
	PULSE_GLOW_RADIUS: 8,
	PULSE_CORE_RADIUS: 2,
	// Colors (from brand palette)
	COLORS: {
		DRESDEN_BLUE: '0, 134, 183',
		PARIS_GREEN: '74, 203, 133',
		FIZZ: '178, 221, 167',
		SLATE: '148, 163, 184'
	}
} as const;

export interface Particle {
	x: number;
	y: number;
	vx: number;
	vy: number;
	radius: number;
	opacity: number;
	pulsePhase: number;
	isNode: boolean;
}

export interface DataPulse {
	fromIndex: number;
	toIndex: number;
	progress: number;
	speed: number;
	color: string;
}

export interface DataStream {
	points: { x: number; y: number }[];
	baseY: number;
	speed: number;
	amplitude: number;
	frequency: number;
	phase: number;
	color: string;
}

export const DATA_STREAM_COLORS = [
	'rgba(0, 134, 183, 0.12)', // Dresden blue
	'rgba(74, 203, 133, 0.10)', // Paris green
	'rgba(178, 221, 167, 0.06)' // Fizz
];

export const PULSE_COLORS = ['rgba(0, 134, 183, 0.9)', 'rgba(74, 203, 133, 0.9)'];
